/* ============================================================
   ENEMY CLOTHING — HEADER
   enemy-header.js
   ============================================================ */

(function () {
  'use strict';

  /* ── Scroll behavior ────────────────────────────────────────── */
  function initScrollHeader() {
    const header = document.querySelector('.ec-header');
    if (!header) return;

    const THRESHOLD = 80;
    let lastScrollY = 0;
    let ticking = false;

    function update() {
      const scrollY = window.scrollY;
      if (scrollY > THRESHOLD) {
        header.classList.add('is-scrolled');
      } else {
        header.classList.remove('is-scrolled');
      }
      lastScrollY = scrollY;
      ticking = false;
    }

    window.addEventListener('scroll', () => {
      if (!ticking) {
        requestAnimationFrame(update);
        ticking = true;
      }
    }, { passive: true });

    update();
  }

  /* ── Mobile menu ────────────────────────────────────────────── */
  function initMobileMenu() {
    const hamburger = document.querySelector('.ec-header__hamburger');
    const menu = document.querySelector('.ec-mobile-menu');
    const overlay = document.querySelector('.ec-menu-overlay');
    const closeBtn = document.querySelector('.ec-mobile-menu__close');

    if (!hamburger || !menu) return;

    function openMenu() {
      menu.classList.add('is-open');
      overlay?.classList.add('is-visible');
      document.body.classList.add('ec-no-scroll');

      const bars = hamburger.querySelectorAll('span');
      if (bars[0]) bars[0].style.transform = 'rotate(45deg) translate(4px, 4px)';
      if (bars[1]) bars[1].style.opacity = '0';
      if (bars[2]) bars[2].style.transform = 'rotate(-45deg) translate(4px, -4px)';
    }

    function closeMenu() {
      menu.classList.remove('is-open');
      overlay?.classList.remove('is-visible');
      document.body.classList.remove('ec-no-scroll');

      const bars = hamburger.querySelectorAll('span');
      bars.forEach(b => { b.style.transform = ''; b.style.opacity = ''; });
    }

    hamburger.addEventListener('click', openMenu);
    closeBtn?.addEventListener('click', closeMenu);
    overlay?.addEventListener('click', closeMenu);

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') closeMenu();
    });
  }

  /* ── Cart icon click → open cart drawer ─────────────────────── */
  function initCartIcon() {
    const cartIcon = document.querySelector('.ec-header__icon--cart');
    if (!cartIcon) return;

    cartIcon.addEventListener('click', () => {
      const drawer = document.querySelector('.ec-cart-drawer');
      const overlay = document.querySelector('.ec-cart-overlay');
      drawer?.classList.add('is-open');
      overlay?.classList.add('is-visible');
      document.body.classList.add('ec-no-scroll');
    });
  }

  /* ── Search icon ─────────────────────────────────────────────── */
  function initSearch() {
    const searchIcon = document.querySelector('.ec-header__icon--search');
    if (!searchIcon) return;

    searchIcon.addEventListener('click', () => {
      const modal = document.querySelector('search-modal') || document.querySelector('.ec-search-modal');
      if (modal) {
        modal.open?.() || modal.classList.add('is-open');
      }
    });
  }

  /* ── Mega menús del header (SHOP NEW COLLECTION, SALE, ...) ──────
     Cada panel vive fuera de .ec-header (por el bug de blur anidado, ver
     enemy-header.liquid), así que ya no es descendiente de su trigger y
     el hover puro por CSS no alcanza para mantenerlo abierto al pasar
     el mouse de uno a otro. Se abren/cierran por JS con un pequeño delay
     de gracia para que no se cierren de golpe al cruzar entre ambos.
     [data-nav-trigger="x"] se empareja con [data-nav-dropdown="x"]. */
  function initNavDropdowns() {
    const triggers = document.querySelectorAll('[data-nav-trigger]');

    triggers.forEach((trigger) => {
      const key = trigger.getAttribute('data-nav-trigger');
      const dropdown = document.querySelector(`[data-nav-dropdown="${key}"]`);
      if (!dropdown) return;

      let closeTimer = null;

      function open() {
        if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
        dropdown.classList.add('is-open');
      }
      function scheduleClose() {
        if (closeTimer) clearTimeout(closeTimer);
        closeTimer = setTimeout(() => { dropdown.classList.remove('is-open'); closeTimer = null; }, 250);
      }
      function closeIfOutside(relatedTarget) {
        if (!trigger.contains(relatedTarget) && !dropdown.contains(relatedTarget)) scheduleClose();
      }

      trigger.addEventListener('mouseenter', open);
      trigger.addEventListener('mouseleave', scheduleClose);
      dropdown.addEventListener('mouseenter', open);
      dropdown.addEventListener('mouseleave', scheduleClose);

      trigger.addEventListener('focusin', open);
      trigger.addEventListener('focusout', (e) => closeIfOutside(e.relatedTarget));
      dropdown.addEventListener('focusout', (e) => closeIfOutside(e.relatedTarget));

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') dropdown.classList.remove('is-open');
      });
    });
  }

  /* ── Active nav link highlight ──────────────────────────────── */
  function initActiveNav() {
    const links = document.querySelectorAll('.ec-header__nav a');
    const currentPath = window.location.pathname;

    links.forEach(link => {
      if (link.getAttribute('href') === currentPath) {
        link.style.color = 'var(--ec-text)';
        link.style.opacity = '1';
      }
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    initScrollHeader();
    initMobileMenu();
    initCartIcon();
    initSearch();
    initNavDropdowns();
    initActiveNav();
  });
})();
